import { updateState } from 'app-webtech-core/reducers/updateState';

const mutationGenerator = (action) => ({
  $set: {
    enabled: action.payload.enabled,
    corpEmbed: action.payload.corpEmbed,
    type: action.payload.type,
    partner: action.payload.partner,
    disableTOSNotification: action.payload.disableTOSNotification,
  },
});

export const setEmbedConfigReducer = (currentState, action) =>
  updateState(currentState, mutationGenerator(action));
